//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vComponent from '@/core/vComponent'
import { mapGetters } from 'vuex'
export default {
  name: 'RecommendPage',
  extends: vComponent,
  props: {
    items: {
      type: Array,
      default: () => []
    },
    memo: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      columns: [ // 欄位宣告
        { name: 'PC_NAME', label: '商品名稱', field: 'PC_NAME' },
        { name: 'PRICE', label: '單價', field: 'PRICE' },
        { name: 'CNT', label: '數量', field: 'CNT' },
        { name: 'TOTAL', label: '金額', field: 'TOTAL' }
      ],
      subPages: [
        { id: 'infoModal', label: '資訊', icon: 'info' },
        { id: 'stockModal', label: '庫存', icon: 'storage' },
        { id: 'rankModal', label: '排行', icon: 'equalizer' },
        { id: 'relatedModal', label: '關聯', icon: 'dashboard' }
      ],
      pagination: {
        page: 1,
        rowsPerPage: 10 // 0 means all rows
      }
    }
  },
  computed: {
    ...mapGetters([
      'theme'
    ]),
    subItems () {
      return this.items.filter(item => {
        return item.type === 'item' || item.type === 'discount'
      })
    },
    paytypeItems () {
      return this.items.filter(item => {
        return item.type === 'paytype'
      })
    }
  },
  created () {
    // console.log(`su item length=${this.subItems.length}`)
    // console.log(this.subItems)
  },
  methods: {
    clickSubBtn (row, type) {
      this.emit(`DetailTable.ShowModal`, type, row.PLU_CODE)
    },
    clickTest (props) {
      console.log(props)
    }

  }
}
